var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, HelperField, ModalBody, ModalFoot, ModalHead, Select, SelectItem, } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import { Component } from 'react';
import { v4 as uuid } from 'uuid';
import { getConfirmButtonVerb } from 'components/powerFlowShared/helpers/getConfirmButtonVerb';
import { AutomationNodeTypes, withTemplates } from 'hocs';
import { durationConverter } from 'utils/duration';
import { getAutoReplyValidity, MIN_WAIT_TIME_BETWEEN_REPLIES, } from '../automationFlow-utils';
class ReplyModalImp extends Component {
    constructor(props) {
        var _a, _b;
        super(props);
        const { node } = props;
        this.state = {
            templateId: ((_a = node.payload) === null || _a === void 0 ? void 0 : _a.templateId) || null,
            templateName: ((_b = node.payload) === null || _b === void 0 ? void 0 : _b.templateName) || '',
            validation: {},
        };
    }
    componentDidMount() {
        const { templates } = this.props;
        return templates.getItems();
    }
    handleConfirm() {
        const errors = this.validate();
        if (Object.keys(errors).length > 0) {
            this.setState({ validation: errors });
            return;
        }
        this.saveNode();
    }
    saveNode() {
        var _a;
        const { replaceNode, node } = this.props;
        const { templateId, templateName } = this.state;
        const nodeOptions = Object.assign(Object.assign({}, node), { nodeType: AutomationNodeTypes.REPLY, isAction: false, isRemovable: true, isEditable: true, payload: {
                templateId: templateId,
                templateName: templateName,
                nextNodeId: ((_a = node.payload) === null || _a === void 0 ? void 0 : _a.nextNodeId) || uuid(),
            } });
        replaceNode(nodeOptions);
        this.closeModal();
    }
    closeModal() {
        this.props.triggerClose();
    }
    getTemplateOptions() {
        return this.props.templates.items.map((t) => {
            return { id: t.id, name: t.name };
        });
    }
    getPagination() {
        const { templates } = this.props;
        return {
            nextEnable: templates.hasNextPage,
            onNext: templates.nextPage,
            previousEnable: templates.hasPreviousPage,
            onPrevious: templates.previousPage,
        };
    }
    onTemplateSearch(searchTerm) {
        const { templates } = this.props;
        if (searchTerm !== undefined && searchTerm !== templates.params.search) {
            templates.paramsChange({ search: searchTerm });
        }
    }
    onTemplateSelect(template) {
        this.setState({
            templateId: template.id,
            templateName: template.name,
            validation: {},
        });
    }
    validate() {
        const errors = {};
        const { templateId } = this.state;
        if (!templateId) {
            errors.template = 'Please select a template';
        }
        return errors;
    }
    render() {
        const { templateId, templateName, validation } = this.state;
        const { nodes, node, nodeLabel } = this.props;
        const { payload } = node;
        const spamProtection = getAutoReplyValidity(nodes)(node);
        const isChanged = (payload === null || payload === void 0 ? void 0 : payload.templateId) !== templateId;
        return (_jsxs(Box, Object.assign({ width: "600px" }, { children: [_jsxs(ModalHead, Object.assign({ title: nodeLabel, onClose: this.closeModal }, { children: ["Send an automatic reply based on a custom template.", _jsx("br", {}), "Auto-reply templates can be created under", ' ', _jsx("strong", { children: "Settings > Templates" }), "."] })), _jsxs(ModalBody, { children: [_jsxs(Box, { children: [_jsx(HelperField, Object.assign({ fieldId: "template", label: "Template", errorMessage: validation.template, required: true }, { children: _jsx(_Fragment, {}) })), _jsx(Select, { itemComponent: SelectItem, items: this.getTemplateOptions(), pagination: this.getPagination(), onSearch: this.onTemplateSearch, onSelect: this.onTemplateSelect, selectedItems: [
                                        { name: templateName, id: templateId !== null && templateId !== void 0 ? templateId : templateName },
                                    ] })] }), _jsxs(Box, Object.assign({ background: "blue.100", borderRadius: true, margin: "500 0 0 0", padding: "300", color: "neutral.900" }, { children: ["As a protective measure against spam, another auto-reply can only be sent after", ' ', durationConverter.toString(MIN_WAIT_TIME_BETWEEN_REPLIES), " have passed.", spamProtection.isInvalid &&
                                    typeof spamProtection.waitTime === 'number' && (_jsxs(_Fragment, { children: [_jsx("br", {}), _jsx("br", {}), "You have", ' ', _jsx("strong", { children: durationConverter.toString(spamProtection.waitTime) ||
                                                'no wait time' }), ' ', "between this and the previous auto-reply."] }))] }))] }), _jsx(ModalFoot, { confirmOnClick: this.handleConfirm, confirmName: getConfirmButtonVerb(node), confirmProps: { disabled: !isChanged }, cancelOnClick: this.closeModal })] })));
    }
}
__decorate([
    boundMethod
], ReplyModalImp.prototype, "handleConfirm", null);
__decorate([
    boundMethod
], ReplyModalImp.prototype, "closeModal", null);
__decorate([
    boundMethod
], ReplyModalImp.prototype, "onTemplateSearch", null);
__decorate([
    boundMethod
], ReplyModalImp.prototype, "onTemplateSelect", null);
export const ReplyModal = withTemplates(ReplyModalImp, {
    initialParams: { type: 'email_auto_reply' },
    itemNormalizer: (item) => {
        var _a;
        return (Object.assign(Object.assign({}, item), { id: (_a = item.id) !== null && _a !== void 0 ? _a : item.name }));
    },
});
